import React from 'react';
import { Mail, MapPin } from 'lucide-react';

const Contact: React.FC = () => {
  return (
    <section id="contact" className="py-24 bg-bg-light">
      <div className="container mx-auto px-6">
        <div className="text-center max-w-2xl mx-auto">
          <h2 className="text-4xl font-semibold mb-4">Let's Connect</h2>
          <p className="text-lg text-slate-600 mb-8">
            I'm currently available for freelance projects and full-time
            opportunities. Feel free to reach out!
          </p>
          <a
            href="mailto:svevafalanga@gmail.com"
            className="btn-primary font-medium py-3 px-8 rounded-full text-lg inline-block flex items-center gap-2 mx-auto w-fit"
          >
            <Mail className="w-5 h-5" />
            svevafalanga@gmail.com
          </a>
          <div className="mt-8 text-slate-500 flex items-center justify-center gap-2">
            <MapPin className="w-4 h-4" />
            <p>Vienna, Austria</p>
          </div>
        </div>
      </div>
    </section>
  );
};

export default Contact; 